import axiosInstance from "../config/axiosInterceptor";

export async function getDevices() {
  return await axiosInstance.get("/api/Device");
}

export async function getDeviceById(id) {
  return await axiosInstance.get(`/api/Device/${id}`);
}

export async function getOnlineDevices() {
  return await axiosInstance.get("/api/Device/GetOnlineDevices");
}

export async function getOnlineDevicesByNodeId(nodeId) {
  return await axiosInstance.get(`/api/Device/GetOnlineDevicesByNodeId/${nodeId}`);
}

export async function isDeviceOnline(deviceSerial) {
  return await axiosInstance.get(`/api/Device/IsDeviceOnline/${deviceSerial}`);
}

export async function createDevice(deviceData) {
  return await axiosInstance.post("/api/Device", deviceData);
}

export async function updateDevice(deviceData) {
  return await axiosInstance.put("/api/Device", deviceData);
}

export async function deleteDevice(id) {
  return await axiosInstance.delete(`/api/Device/${id}`);
}

export async function isNodeDeviceOnline(serial) {
  return await axiosInstance.get(`/api/Device/isNodeDeviceOnline/${serial}`);
}